import React from "react";
import Loader from "@erelego/design-system/components/atoms/Loader";
import { StyledLazyLoaderContainer } from "@common/components/LazyLoad/StyledLazyLoader";
interface ILazyload {
  children: React.ReactNode;
  isFullPage?: boolean;
  hideLoader?: boolean;
}

export const LazyLoad = (props: ILazyload) => {
  const { children, isFullPage, hideLoader } = props;
  return (
    <React.Suspense
      fallback={
        hideLoader ? null : (
          <StyledLazyLoaderContainer>
            <Loader isFullPage={isFullPage} />
          </StyledLazyLoaderContainer>
        )
      }>
      {children}
    </React.Suspense>
  );
};

export default LazyLoad;
